<template>
  <div :class="['pt-10 pb-5 component-div', isRTLlang(lang) ? 'rtl mrgn-rt-25' : '']">
    <b-row>
      <b-col cols="12" class="pl-14 d-flex" v-if="isDisplayQuestionInfo">
        <div class="number-sequence" :class="isFieldDisabled ? 'disable-question' : ''">
          <span class="cursor_pointer1" v-if="(activityInfo.showNumericLabels || activityInfo.showNumericLabels == undefined || activityInfo.showNumericLabels == null || componentData.sequence) && activityInfo.showNumericLabels">{{ componentData.stepSequence ? componentData.stepSequence : componentData.sequence }} </span>
          <span class="cursor_pointer1" v-else-if="componentData.sequence && (activityInfo.showNumericLabels == undefined || activityInfo.showNumericLabels == null)">{{ componentData.sequence }} </span>
        </div>
        <span
          class="ml-2 question-tital-name"
          :class="isFieldDisabled ? 'disable-question' : ''"
          v-translate:_formattedBody="{
            key: translationKeyInitial,
            val: lang,
            html: componentData.formattedBody
          }"
          v-html="componentData.formattedBody"
        ></span>
        <span class="activity-form-preview-components__optional-box ml-15 d-inline-box pt-2" :class="isFieldDisabled ? 'disable-question' : ''" v-if="componentData.isSkippable" v-translate:_optional="{ key: 'label', val: lang, html: 'Optional' }">Optional</span>
        <div v-if="isFieldDisabled" class="skipped-question-box ml-15 d-inline-box pt-2 nonOpaque" v-translate:_skipped="{ key: 'label', val: lang, html: 'Skipped' }">
          Skipped
        </div>
        <div class="ml-5" v-if="componentData && componentData.notifications && componentData.notifications.length > 0 && isNotificationIcon">
          <img alt="Bell icon" src="@/assets/NotificaionIcon.png" data-v-c76994f4 />
        </div>
        <span class="text-danger pl-5 fw-bold" v-if="hasFieldError">{{ fieldErrorText }}</span>
        <span class="text-warning pl-5 fw-bold" v-else-if="hasFieldWarning">{{ fieldWarningText }}</span>
      </b-col>
    </b-row>

    <!-- PREVIEW MODE -->
    <template v-if="mode == 0">
      <div class="pl-0 pt-10" v-if="!componentData.verticalScale" :class="!!componentData.numericRatingScale ? 'd-inline-block' : ''">
        <div class="row" v-if="activityInfo && activityInfo.newLayout == true">
          <div class="pl-0 pr-7 col-md-2">
            {{ componentData.minValueLabel }}
          </div>
          <dsSlider
            :ref="'slider_' + componentData.id"
            v-if="!componentData.verticalScale"
            :value="getValueForNumberScale()"
            :piecewise="true"
            direction="horizontal"
            class="horizontal-vue-slider pt-30 pb-25 mb-5 col-md-8"
            :class="{ 'box-slider': !!componentData.numericRatingScale }"
            :data="componentData.formattedLabels"
            :piecewiseLabel="true"
            :min="componentData.minValue"
            :max="componentData.maxValue"
            :interval="componentData.partitions"
            :name="'slider_' + componentData.id"
            :isNumericRatingScale="!!componentData.numericRatingScale"
            disabled
          />
          <div class="pt-10 scaleLabels">
            <div
              v-translate:_minValueLabel="{
                key: translationKeyInitial,
                val: lang,
                html: componentData.minValueLabel
              }"
              class="pull-left"
            >
              {{ componentData.minValueLabel }}
            </div>
            <div
              v-translate:_maxValueLabel="{
                key: translationKeyInitial,
                val: lang,
                html: componentData.maxValueLabel
              }"
              class="pull-right"
            >
              {{ componentData.maxValueLabel }}
            </div>
          </div>
        </div>
        <div v-else>
          <div class="pl-40 pt-40" v-if="!componentData.verticalScale">
            <dsSlider
              :ref="'slider_' + componentData.id"
              v-if="!componentData.verticalScale"
              :value="getValueForNumberScale()"
              :piecewise="true"
              direction="horizontal"
              class="horizontal-vue-slider pl-20 pt-20 mb-5"
              :class="!!componentData.numericRatingScale ? 'box-slider' : 'pb-25'"
              :data="componentData.formattedLabels"
              :piecewiseLabel="true"
              :min="componentData.minValue"
              :max="componentData.maxValue"
              :interval="componentData.partitions"
              :name="'slider_' + componentData.id"
              :isNumericRatingScale="!!componentData.numericRatingScale"
              disabled
            />
            <div class="scaleLabels d-flex justify-content-between" :class="!!componentData.numericRatingScale ? '' : 'pt-10'">
              <div class="labels text-break-view">
                {{ componentData.minValueLabel }}
              </div>
              <div :class="['labels w-115', isRTLlang(lang) ? '' : 'right-label']">
                {{ componentData.maxValueLabel }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="pl-40 pt-40" v-else>
        <div
          v-if="componentData && componentData.maxValueLabel"
          v-translate:_maxValueLabel="{
            key: translationKeyInitial,
            val: lang,
            html: componentData.maxValueLabel
          }"
          class="scaleLabels first"
        >
          {{ componentData.maxValueLabel }}
        </div>
        <dsSlider
          :ref="'slider_' + componentData.id"
          v-if="componentData.verticalScale"
          :value="getValueForNumberScale()"
          :piecewise="true"
          width="5"
          height="350px"
          direction="vertical"
          class="vertical-vue-slider pl-20 mb-5"
          :data="componentData.formattedLabels"
          :piecewiseLabel="true"
          :min="componentData.minValue"
          :max="componentData.maxValue"
          :interval="componentData.partitions"
          :name="'slider_' + componentData.id"
          :isNumericRatingScale="!!componentData.numericRatingScale"
          disabled
        />
        <div
          v-if="componentData && componentData.verticalScale && componentData.minValueLabel"
          v-translate:_minValueLabel="{
            key: translationKeyInitial,
            val: lang,
            html: componentData.minValueLabel
          }"
          class="scaleLabels last"
        >
          {{ componentData.minValueLabel }}
        </div>
      </div>
      <b-col cols="8"></b-col>
    </template>

    <!-- EDIT MODE -->
    <template v-else-if="mode == 1">
      <b-row class="pl-30" :class="isFieldDisabled ? 'disable-question' : ''">
        <b-col :cols="isRTLlang(lang) && componentData.numericRatingScale ? '0' : '8'" :class="['mt-10', isRTLlang(lang) && !componentData.numericRatingScale ? 'number-scale-alignment-rtl' : '']">
          <div v-if="!componentData.verticalScale" :class="!!componentData.numericRatingScale ? 'd-inline-block' : ''">
            <dsSlider
              :ref="'slider_' + componentData.id"
              v-if="!componentData.verticalScale && componentData.numericRatingScale"
              :value="getValueForNumberScale()"
              :piecewise="true"
              direction="horizontal"
              class="horizontal-vue-slider mt-15 pt-20 mb-5"
              :class="!!componentData.numericRatingScale ? 'box-slider' : 'pb-25'"
              :data="componentData.formattedLabels"
              :piecewiseLabel="true"
              :name="'slider_' + componentData.id"
              :min="componentData.minValue"
              :max="componentData.maxValue"
              :interval="componentData.partitions"
              :disabled="isFieldDisabled"
              @click.native="onFieldChange"
              :clickable="false"
              :isNumericRatingScale="!!componentData.numericRatingScale"
              :defaultSelected="numericScaleSelected"
            />
            <dsSlider
              :ref="'slider_' + componentData.id"
              v-if="!componentData.verticalScale && !componentData.numericRatingScale"
              :value="getValueForNumberScale()"
              :piecewise="true"
              direction="horizontal"
              class="horizontal-vue-slider mt-15 pt-20 mb-5"
              :class="!!componentData.numericRatingScale ? 'box-slider' : 'pb-25'"
              :data="componentData.formattedLabels"
              :piecewiseLabel="true"
              :name="'slider_' + componentData.id"
              :min="componentData.minValue"
              :max="componentData.maxValue"
              :interval="componentData.partitions"
              :disabled="isFieldDisabled"
              @drag-end="onFieldChange"
              :clickable="isClickable"
              :dotSize="pointerValue"
              :tooltip="showTooltip"
              @click.native="showPointer"
            />
            <div class="scaleLabels d-flex justify-content-between" :class="!!componentData.numericRatingScale ? '' : 'pt-10'">
              <div
                v-translate:_minValueLabel="{
                  key: translationKeyInitial,
                  val: lang,
                  html: componentData.minValueLabel
                }"
                class="labels text-break"
              >
                {{ componentData.minValueLabel }}
              </div>
              <div
                v-translate:_maxValueLabel="{
                  key: translationKeyInitial,
                  val: lang,
                  html: componentData.maxValueLabel
                }"
                :class="['labels w-115', isRTLlang(lang) ? '' : 'right-label']"
              >
                {{ componentData.maxValueLabel }}
              </div>
            </div>
          </div>
          <div class="pl-40 pt-40" v-else>
            <div
              v-if="componentData && componentData.maxValueLabel"
              v-translate:_maxValueLabel="{
                key: translationKeyInitial,
                val: lang,
                html: componentData.maxValueLabel
              }"
              :class="['scaleLabels first', isRTLlang(lang) ? 'float-right mrgn-rt-25' : '']"
            >
              {{ componentData.maxValueLabel }}
            </div>
            <dsSlider
              :ref="'slider_' + componentData.id"
              v-if="componentData.verticalScale && componentData.numericRatingScale"
              :value="getValueForNumberScale()"
              :piecewise="true"
              width="5"
              height="350px"
              direction="vertical"
              class="vertical-vue-slider pl-50"
              :data="componentData.formattedLabels"
              :piecewiseLabel="true"
              :min="componentData.minValue"
              :max="componentData.maxValue"
              :interval="componentData.partitions"
              :disabled="isFieldDisabled"
              @click.native="onFieldChange"
              :name="'slider_' + componentData.id"
              :clickable="false"
              :isNumericRatingScale="!!componentData.numericRatingScale"
              :defaultSelected="numericScaleSelected"
            />
            <dsSlider
              :ref="'slider_' + componentData.id"
              v-if="componentData.verticalScale && !componentData.numericRatingScale"
              :value="getValueForNumberScale()"
              :piecewise="true"
              width="5"
              height="350px"
              direction="vertical"
              class="vertical-vue-slider pl-50"
              :data="componentData.formattedLabels"
              :piecewiseLabel="true"
              :min="componentData.minValue"
              :max="componentData.maxValue"
              :interval="componentData.partitions"
              :disabled="isFieldDisabled"
              @drag-end="onFieldChange"
              :name="'slider_' + componentData.id"
              :clickable="isClickable"
              :dotSize="pointerValue"
              :tooltip="showTooltip"
              @click.native="showPointer"
            />
            <div
              v-if="componentData && componentData.verticalScale && componentData.minValueLabel"
              v-translate:_minValueLabel="{
                key: translationKeyInitial,
                val: lang,
                html: componentData.minValueLabel
              }"
              :class="['scaleLabels last', isRTLlang(lang) ? 'float-right mrgn-rt-25' : '']"
            >
              {{ componentData.minValueLabel }}
            </div>
          </div>
        </b-col>
        <b-col cols="4"> </b-col>
      </b-row>
      <div :class="[isRTLlang(lang) ? 'float-right' : '', isFieldDisabled ? 'disable-question' : '']">
        <span class="activity-form__clear pl-55" :class="{ clearOptionDisabled: isFieldDisabled }" v-translate:_CLEAR="{ key: 'BUTTON', val: lang, html: 'Clear' }" @click="clearAnswer">Clear</span>

        <div class="d-inline-block ml-18" v-if="activityInfo.canScoreResponses">
          <label class="fs-12 pl-5" v-translate:_score="{ key: 'label', val: lang, html: 'Score' }">Score</label>
          <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
            {{ componentData.actualScore || showScore(componentData.skipScore) }}
          </div>
        </div>
      </div>
      <div v-if="isRTLlang(lang)" :class="[isRTLlang(lang) ? 'clearfix' : '']"></div>
    </template>

    <template v-else-if="mode == 2">
      <span :class="{ 'query-icon': isEdited }"></span>
      <b-row>
        <b-col :class="componentData.isEditedVersion ? 'col-6' : 'col-10'" class="pl-30">
          <span class="changed" v-if="componentData.isEditedVersion"></span>
          <div :class="['answers ml-16', isRTLlang(lang) ? 'float-right' : '']">
            {{ componentData.answer }}
          </div>
          <div v-if="isRTLlang(lang)" :class="[isRTLlang(lang) ? 'clearfix' : '']"></div>
          <b-row class="pt-5">
            <div class="d-inline-block ml-16" v-if="activityInfo.canScoreResponses">
              <label class="pl-5" v-translate:_score="{ key: 'label', val: lang, html: 'Score' }">Score</label>
              <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
                {{ showScore(componentData.actualScore) || showScore(componentData.skipScore) }}
              </div>
            </div>
          </b-row>
        </b-col>
        <b-col v-if="componentData.isEditedVersion" class="col-6 previous-answer">
          <span class="previous-value-mark"></span>
          <div
            class="answers previous-value"
            v-translate="{
              key: 'label_previous_value',
              val: lang,
              html: 'Previous value'
            }"
          >
            Previous value
          </div>
          <div>{{ componentData.previousAnswer }}</div>
          <b-row class="pt-5" v-if="componentData.previousAnswer">
            <div class="d-inline-block" v-if="activityInfo.canScoreResponses">
              <label v-translate:_score="{ key: 'label', val: lang, html: 'Score' }">Score</label>
              <div class="ml-10 activity-form__score-box d-inline-block color_4c8ce4">
                {{ showScore(componentData.previousActualScore) }}
              </div>
            </div>
          </b-row>
        </b-col>
      </b-row>
    </template>
  </div>
</template>

<script>
import dsSlider from "@/lib/ds-slider-component";
import langTranslate from "./lang-translate";

export default {
  name: "activity-form-number-scale-preview",

  mixins: [langTranslate],

  data() {
    return {
      hasFieldError: false,
      fieldErrorText: "",
      hasFieldWarning: false,
      fieldWarningText: "",
      pointerValue: 0,
      showTooltip: false,
      isClickable: true,
      numericScaleSelected: false
    };
  },

  props: {
    componentData: {},
    isDisplayQuestionInfo: {
      default: true
    },
    isFieldDisabled: {
      type: Boolean,
      default: false
    },
    mode: {
      default: 0
    },
    isEdited: null,
    activityInfo: {
      default: () => {}
    },
    triggerValidate: {
      type: Boolean,
      default: false
    },
    isNotificationIcon: Boolean,
    nextStepSequence: null,
    isClearData: {
      type: Boolean,
      default: false
    },
    completeEdit: {
      type: Boolean,
      default: false
    }
  },

  components: {
    dsSlider
  },
  watch: {
    isFieldDisabled(val) {
      if (val === true && this.componentData.branchingConfigured && !!this.componentData.answer && !!this.nextStepSequence && this.nextStepSequence === this.componentData.stepSequence + 1) {
        this.clearAnswer();
      } else if (val === true) {
        this.resetField();
      }
    },
    isClearData: {
      deep: true,
      handler(val) {
        if (val === true) {
          this.clearAnswer();
        }
      }
    },
    triggerValidate() {
      if (!this.isFieldDisabled) {
        this.checkForFieldErrors();
      }
    }
  },
  mounted() {
    this.componentData.answer = this.getValueForNumberScale();
    if (this.completeEdit) {
      this.componentData.defaultAnswer = this.componentData.answer;
    } else {
      this.componentData.defaultAnswer = "";
    }
    if (this.componentData) {
      const $this = this;
      setTimeout(() => {
        const slider = "slider_" + this.componentData.id;
        if ($this.$refs[slider]) {
          $this.$refs[slider].refresh();
        }
      }, 5000);
    }
    if (this.mode == 1) {
      this.$emit("initAnswerChange", this.componentData);
      if (!this.componentData.numericRatingScale) {
        if (this.componentData.answer) {
          this.pointerValue = 16;
          this.showTooltip = "always";
          this.isClickable = false;
        }
      } else if (this.componentData.numericRatingScale) {
        if (this.componentData.answer) {
          this.numericScaleSelected = true;
        }
      }
    }
    if (this.mode == 0 || this.mode == 2) {
      if (this.componentData.isSkippable && this.componentData.answer == "") {
        this.componentData.actualScore = this.componentData.skipScore;
        this.componentData.computedScore = this.componentData.skipScore;
      }
    }
    if (this.mode == 2) {
      if (this.componentData.isSkippable && this.componentData.answer == "") {
        this.componentData.previousActualScore = this.componentData.skipScore;
      }
    }
  },
  methods: {
    isRTLlang(lang) {
      return lang == "he" || lang == "ar-IL";
    },
    showScore(score) {
      if (score) {
        return score;
      }
      return 0;
    },
    resetField() {
      this.pointerValue = 0;
      this.showTooltip = false;
      this.isClickable = true;
      this.componentData.answer = undefined;
      this.componentData.dataChecks = [];
      this.componentData.computedScore = 0;
      this.componentData.actualScore = 0;
      this.componentData.answer = this.getValueForNumberScale();
      this.componentData.defaultAnswer = "";
      this.resetAllErrors();
      this.$emit(`getQuestionScores`);
      this.$forceUpdate();
    },
    clearAnswer() {
      this.pointerValue = 0;
      this.showTooltip = false;
      this.isClickable = true;
      this.numericScaleSelected = false
      this.resetField();
      this.$emit("onClearAnswer", this.componentData);
    },
    onFieldChange(event) {
      this.numericScaleSelected = true;
      if (!this.isFieldDisabled) {
        if (this.componentData.numericRatingScale) {
          this.componentData.answer = event.target._value;
        } else {
          this.componentData.answer = event.val;
        }
        this.componentData.defaultAnswer = this.componentData.answer;
        this.checkForFieldErrors();
        this.onAnswerChange();
      }
    },
    resetAllErrors() {
      this.hasFieldError = false;
      this.fieldErrorText = "";
      this.hasFieldWarning = false;
      this.fieldWarningText = "";
    },
    checkForFieldErrors() {
      let { isSkippable, answer, dataEditChecks } = this.componentData;
      this.resetAllErrors();

      this.componentData.dataChecks = [];

      if (this.isFieldDisabled) {
        return;
      }
      let softDataCheck;

      if (dataEditChecks) {
        softDataCheck = false;
        for (let k = 0; k < dataEditChecks.length; k++) {
          if (dataEditChecks[k].check == "SOFT") {
            if (dataEditChecks[k].type == "LESS_THAN" && dataEditChecks[k].value < answer) {
              this.hasFieldError = false;
              this.hasFieldWarning = true;
              this.fieldErrorText = "";
              this.fieldWarningText = `Your response is greater than the expected range ${dataEditChecks[k].value}. Please review your response.`;
              this.componentData.dataChecks.push({
                dataCheckId: dataEditChecks[k].id,
                dataCheckType: dataEditChecks[k].type,
                message: this.fieldWarningText
              });
              softDataCheck = true;
            }
            if (dataEditChecks[k].type == "GREATER_THAN" && dataEditChecks[k].value > answer) {
              this.hasFieldError = false;
              this.hasFieldWarning = true;
              this.fieldErrorText = "";
              this.fieldWarningText = `Your response is less than the expected range ${dataEditChecks[k].value}. Please review your response.`;
              this.componentData.dataChecks.push({
                dataCheckId: dataEditChecks[k].id,
                dataCheckType: dataEditChecks[k].type,
                message: this.fieldWarningText
              });
              softDataCheck = true;
            }
          } else {
            if (dataEditChecks[k].type == "GREATER_THAN" && dataEditChecks[k].value > answer) {
              this.hasFieldWarning = false;
              this.hasFieldError = true;
              this.fieldWarningText = "";
              this.fieldErrorText = `Please enter a response greater than ${dataEditChecks[k].value}.`;
              isSkippable = false;
            } else if (dataEditChecks[k].type == "LESS_THAN" && dataEditChecks[k].value < answer) {
              this.hasFieldWarning = false;
              this.hasFieldError = true;
              this.fieldWarningText = "";
              this.fieldErrorText = `Please enter a response less than ${dataEditChecks[k].value}.`;
              isSkippable = false;
            }
          }
        }
        if (softDataCheck) {
          return false;
        }
      }

      if (!isSkippable && (answer === "" || answer === undefined)) {
        this.hasFieldError = true;
        this.fieldErrorText = this.translateToActiveLang("validation_error_required", "This field is required.");
      } else if (isSkippable && (answer === "" || answer === undefined) && dataEditChecks.length > 0 && softDataCheck) {
        this.hasFieldWarning = true;
        this.fieldWarningText = `This field is required.`;
      }
    },
    getValueForNumberScale() {
      if (this.componentData.answer || this.componentData.answer === 0) {
        return this.componentData.answer;
      } else {
        return undefined;
      }
    },
    onAnswerChange() {
      this.$nextTick(() => {
        this.componentData.computedScore = this.componentData.answer;
        this.componentData.actualScore = this.componentData.answer;
        this.$emit("onAnswerChange", this.componentData);
      });
    },
    showPointer(event) {
      this.pointerValue = 16;
      this.showTooltip = "always";
      let answer;
      if (event.target.__vue__) {
        answer = event.target.__vue__.val;
      } else if (event.target.parentElement.__vue__) {
        answer = event.target.parentElement.__vue__.val;
      }
      if (this.isClickable == true) {
        this.isClickable = false;
        this.componentData.answer = answer;
        this.componentData.computedScore = answer;
        this.componentData.actualScore = answer;
        this.$emit("onAnswerChange", this.componentData);
      }
    }
  }
};
</script>
<style scoped lang="scss">
@import "@/assets/edit-site-partcipant-activity.scss";
.changed {
  position: absolute;
  left: 0;
  top: 0;
  width: 10px;
  height: 60px;
  border-radius: 1px;
  background-color: #ffa200;
}

.previous-value-mark {
  width: 3px;
  height: 65px;
  background-color: #ffa200;
  border-radius: 1px;
  left: 0;
  top: 4px;
  position: absolute;
}

.answers {
  font-weight: 600;
}

.previous-answer {
  opacity: 0.8;
}

.previous-value {
  color: #ffa200;
  opacity: 0.8;
  font-size: 10px;
  font-weight: bold;
  text-transform: uppercase;
  margin-bottom: 9px;
  letter-spacing: 2.4px;
  margin-top: 3px;
}
.scaleLabels {
  font-size: 12px;
  color: #666669;
  .labels {
    max-width: 55px;
    width: 100%;
  }
}
.scaleLabels.first {
  max-width: 100%;
  padding-left: 30px;
}
.scaleLabels.last {
  padding-left: 30px;
}
.activity-form__clear {
  width: 29px;
  height: 14px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #4c8ce4;
}
.number-sequence {
  min-width: 30px;
  display: inline-block;
}
.component-div {
  border-top: 1px solid #fefefe;
  border-bottom: 1px solid #d3dfe4;
}
.cursor_pointer1 {
  cursor: pointer;
  width: 22px;
  height: 20px;
  border-radius: 4px;
  background-color: #c4c4c4;
  display: inline-block;
  color: #fff;
  text-align: center;
}
.clearOptionDisabled {
  pointer-events: none !important;
}
.right-label {
  position: relative;
  left: 2px;
  text-align: right;
  word-break: break-word;
}
.text-break {
  word-break: break-word;
}
.text-break-view {
  word-break: break-word;
  position: relative;
  left: 10px;
}
</style>
<style>
.box-slider .vue-box-select li {
  margin: 0 8px !important;
}
.rtl .number-scale-alignment-rtl {
  margin-right: 40px;
}
</style>
